export default "__VITE_ASSET__CcbAwcEX__"